import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import menu_icon from "../Images/menu-icon.svg";
import alllogo from "../Images/back.png";
import Footer from "../Components/Footer";
import Menu from "../Components/Menu";

import { MdOutlineMail } from "react-icons/md";
import { RiWhatsappFill } from "react-icons/ri";
import { FaCopy, FaFacebook, FaFacebookMessenger } from "react-icons/fa";

import { getReferalCodeApi } from "../Data/data";
import "../Css/newcss.css";

export const ReferFriend = () => {
    const [referralCode, setReferralCode] = useState("");
    const [copied, setCopied] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const ani = localStorage.getItem("ani");

        if (ani) {
            axios.get(`${getReferalCodeApi}?ani=${ani}`)
                .then((response) => {
                    const code = response.data;
                    if (code) {
                        setReferralCode(code);

                        const currentUrl = new URL(window.location.href);
                        currentUrl.searchParams.set("refId", code);
                        window.history.replaceState({}, '', currentUrl.toString());
                    } else {
                        toast.error("Failed to get referral code.");
                    }
                })
                .catch((err) => {
                    console.error("Error fetching referral code:", err);
                    toast.error("Something went wrong while getting referral code.");
                });
        } else {
            toast.warn("ANI not found in localStorage.");
        }
    }, []);

    const fullLink = `http://142.132.149.12:5274/subscribe?refId=${referralCode}`;
    const shareMessage = `Join Bigcash Games using my referral link:-\n${fullLink}`;
    const encodedMessage = encodeURIComponent(shareMessage);

console.log(encodedMessage,"===encodedmessage===")
    const handleCopy = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(fullLink)
                .then(() => {
                    setCopied(true);
                    toast.success("Referral link copied!");
                })
                .catch((err) => {
                    fallbackCopy(fullLink);
                });
        } else {
            fallbackCopy(fullLink);
        }
    };

    const fallbackCopy = (text) => {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        setCopied(true);
        toast.success("Referral link copied!");
    };

    return (
        <>
            <ToastContainer />
            <Menu one="active" two="inactive" three="inactive" four="inactive" five="inactive" six="inactive" />

            <div className="container bg-color-yellow main-home">
                <div className="cus-header">
                    <div className="col-md-6 col-xs-6">
                        <div className="page-icon">
                            <img src={alllogo} alt="alllogo" />
                            <Link to={"/homepage"}>Refer A Friend</Link>
                        </div>
                    </div>
                    <div className="col-md-6 col-xs-6">
                        <span className="cus-menu navbar-toggle collapsed">
                            <img alt="logo" src={menu_icon} />
                            <span className="text-unselect cursor-pointer">menu</span>
                        </span>
                    </div>
                </div>

                <div className="refer-section px-4 py-6">
                    <div className="refer-code-box">
                        <div className="code-text">{referralCode || "Loading..."}</div>
                        <button className="copy-button" onClick={handleCopy}>
                            <FaCopy />
                        </button>
                    </div>

                    {copied && <p className="copied-text">Copied successfully!</p>}
                    <p className="tap-to-copy">Tap to copy code</p>

                    <p className="share-text">Share through</p>


<div className="share-icons flex gap-4 justify-center mt-4">
  <a
    href={`https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent("Join Bigcash Games")}&body=${encodeURIComponent(shareMessage)}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <MdOutlineMail size={35} />
  </a>

  <a
    href={`https://wa.me/?text=${encodedMessage}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <RiWhatsappFill size={35} color="green" />
  </a>

  {/* Facebook */}
  <a
    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullLink)}&quote=${encodeURIComponent(shareMessage)}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaFacebook size={35} color="#0e60ad" />
  </a>

  {/* Messenger */}
  <a
    href={`https://www.facebook.com/dialog/send?link=${encodeURIComponent(fullLink)}&app_id=YOUR_FACEBOOK_APP_ID&redirect_uri=${encodeURIComponent(fullLink)}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaFacebookMessenger size={35} color="#5ea7eb" />
  </a>
</div>


                    <div className="how-it-works mt-5">
                        <p className="how-title">How does it work?</p>
                        <ul className="how-list">
                            <li>Share your unique referral code with friends.</li>
                            <li>When they sign up and play Bigcash Games MTN, you earn points that can be redeemed for prizes, cash, and more!</li>
                        </ul>
                    </div>
                </div>

                <div className="btn">
                    <div className="button-container" onClick={() => navigate('/referal-points')}>
                        <p className="button-text">My Referral Points</p>
                    </div>
                    <hr className="divider-line" />
                    <Footer one="active" two="inactive" three="inactive" four="inactive" />
                </div>
            </div>
        </>
    );
};


// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import 'react-toastify/dist/ReactToastify.css';

// import menu_icon from "../Images/menu-icon.svg";
// import alllogo from "../Images/back.png";
// import Footer from "../Components/Footer";
// import Menu from "../Components/Menu";

// import { MdOutlineMail } from "react-icons/md";
// import { RiWhatsappFill } from "react-icons/ri";
// import { FaCopy, FaFacebook, FaFacebookMessenger } from "react-icons/fa";
// import { FcGoogle } from "react-icons/fc";

// import {getReferalCodeApi} from "../Data/data";

// import "../Css/newcss.css";

// export const ReferFriend = () => {
//     const [mobileNumber, setMobileNumber] = useState("");
//     const [referralCode, setReferralCode] = useState("");
//     const [copied, setCopied] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//     const ani = localStorage.getItem("ani");

//     if (ani) {
//         axios
//             .get(`${getReferalCodeApi}?ani=${ani}`)
//             .then((response) => {
//                 const code = response.data; // Since backend returns plain string

//                 if (code) {
//                     setReferralCode(code);

//                     // Add referral code to URL
//                     const currentUrl = new URL(window.location.href);
//                     currentUrl.searchParams.set("refId", code);
//                     window.history.replaceState({}, '', currentUrl.toString());
//                 } else {
//                     toast.error("Failed to get referral code.");
//                 }
//             })
//             .catch((err) => {
//                 console.error("Error fetching referral code:", err);
//                 toast.error("Something went wrong while getting referral code.");
//             });
//     } else {
//         toast.warn("ANI not found in localStorage.");
//     }
// }, []);


//     // const handleCopy = () => {
//     //     const fullLink = `http://142.132.149.12:5274/subscribe?refId=${referralCode}`;
//     //     navigator.clipboard.writeText(fullLink);
//     //     setCopied(true);
//     //     toast.success("Referral link copied!");
//     // };


//     const handleCopy = () => {
//     const fullLink = `http://142.132.149.12:5274/subscribe?refId=${referralCode}`;

//     if (navigator.clipboard && navigator.clipboard.writeText) {
//         navigator.clipboard.writeText(fullLink)
//             .then(() => {
//                 setCopied(true);
//                 toast.success("Referral link copied!");
//             })
//             .catch((err) => {
//                 console.error("Clipboard write failed:", err);
//                 fallbackCopy(fullLink);
//             });
//     } else {
//         fallbackCopy(fullLink);
//     }
// };

// const fallbackCopy = (text) => {
//     const textarea = document.createElement("textarea");
//     textarea.value = text;
//     textarea.setAttribute("readonly", "");
//     textarea.style.position = "absolute";
//     textarea.style.left = "-9999px";
//     document.body.appendChild(textarea);
//     textarea.select();
//     document.execCommand("copy");
//     document.body.removeChild(textarea);
//     setCopied(true);
//     toast.success("Referral link copied!");
// };


//     return (
//         <>
//             <ToastContainer />
//             <Menu
//                 one="active"
//                 two="inactive"
//                 three="inactive"
//                 four="inactive"
//                 five="inactive"
//                 six="inactive"
//             />
//             <div className="container bg-color-yellow main-home">
//                 <div className="cus-header">
//                     <div className="col-md-6 col-xs-6">
//                         <div className="page-icon">
//                             <img src={alllogo} alt="allogo" />
//                             <Link to={"/homepage"}>Refer A Friend</Link>
//                         </div>
//                     </div>
//                     <div className="col-md-6 col-xs-6">
//                         <span className="cus-menu navbar-toggle collapsed">
//                             <img alt="logo" src={menu_icon} />
//                             <span className="text-unselect cursor-pointer">menu</span>
//                         </span>
//                     </div>
//                 </div>

//                 <div className="refer-section px-4 py-6">
//                     <div className="refer-code-box">
//                         <div className="code-text">{referralCode || "Loading..."}</div>
//                         <button className="copy-button" onClick={handleCopy}>
//                             <FaCopy />
//                         </button>
//                     </div>

//                     {copied && <p className="copied-text">Copied successfully!</p>}
//                     <p className="tap-to-copy">Tap to copy code</p>

//                     {/* <div className="mobile-input-container">
//                         <label className="mobile-label">Mobile number</label>
//                         <input
//                             type="tel"
//                             className="mobile-input"
//                             value={mobileNumber}
//                             onChange={(e) => setMobileNumber(e.target.value)}
//                             maxLength={10}
//                             placeholder=""
//                         />
//                     </div> */}

//                     {/* <p className="note-text mt-1">
//                         Note: This number should be used by your friend while subscribing to Bigcash Games.
//                     </p> */}

//                     <p className="share-text">Share through</p>

                   
// <div className="share-icons">
//     <a
//         href={`https://mail.google.com/mail/?view=cm&fs=1&to=&su=Join Bigcash Games&body=Use my referral link ${fullLink} to join Bigcash Games!`}
//         target="_blank"
//         rel="noopener noreferrer"
//     >
//         <MdOutlineMail size={35} />
//     </a>
//     <a
//         href={`https://wa.me/?text=Use my referral link ${fullLink} to join Bigcash Games!`}
//         target="_blank"
//         rel="noopener noreferrer"
//     >
//         <RiWhatsappFill size={35} color="green" />
//     </a>
//     <a
//         href={`https://www.facebook.com/sharer/sharer.php?u=${fullLink}&quote=Use my referral link to join Bigcash Games!`}
//         target="_blank"
//         rel="noopener noreferrer"
//     >
//         <FaFacebook size={35} color="#0e60ad" />
//     </a>
//     <a
//         href={`https://www.facebook.com/dialog/send?link=${fullLink}&app_id=YOUR_FACEBOOK_APP_ID&redirect_uri=https://bigcashmtnzm.com`}
//         target="_blank"
//         rel="noopener noreferrer"
//     >
//         <FaFacebookMessenger size={35} color="#5ea7eb" />
//     </a>
// </div>


//                     <div className="how-it-works mt-5">
//                         <p className="how-title">How does it work?</p>
//                         <ul className="how-list">
//                             <li>Share your unique referral code with friends.</li>
//                             <li>
//                                 When they sign up and play Bigcash Games MTN, you earn points that can be redeemed
//                                 for prizes, cash, and more!
//                             </li>
//                         </ul>
//                     </div>
//                 </div>

//                 <div className="btn">
//                     <div className="button-container" onClick={() => navigate('/referal-points')}>
//                         <p className="button-text">My Referral Points</p>
//                     </div>
//                     <hr className="divider-line" />
//                     <Footer
//                         one="active"
//                         two="inactive"
//                         three="inactive"
//                         four="inactive"
//                     />
//                 </div>
//             </div>
//         </>
//     );
// };
